/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import AppComponent from './AppComponent/index'
import Launchers from './Launchers/index'
import No from './No/index'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'
import Tysiav2Dashboard from 'DesignSystem/Svgs/Tysiav2Dashboard/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/Apps/Content",
  setOuterRef,
  isSelected,
  colorActive,
  left,
  top,
  setInnerRef,
  isHovered
  
}) {
  let flow = fromFlow.useFlow()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let colorActiveOrdtColorsGreen700 = colorActive ?? dtColorsGreen700
let colorActiveOrdtColorsGreen7001 = colorActive ?? dtColorsGreen700
let colorActiveOrdtColorsGreen7002 = colorActive ?? dtColorsGreen700
let colorActiveOrdtColorsGreen7003 = colorActive ?? dtColorsGreen700
  return (<React.Fragment
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 hasDownArrow={true}
 marginTop={dtSpaceXs}
 innerRef={setOuterRef}
 text="Apps"
 size="normal"
 color={dtColorsNeutral900}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Launchers')) ? true : false}
 onClick={flow.has(fromFlow.normalizePath(viewPath, 'Launchers')) ? () => setFlowTo(fromFlow.normalizePath(viewPath, 'No')) : () => setFlowTo(fromFlow.normalizePath(viewPath, 'Launchers'))}
>
{childProps => (
<Tysiav2Dashboard
{...childProps}
  viewPath={`${viewPath}/Tysiav2Dashboard`}
 width={12}
 height={12}
 fill2={childProps.isSelected ? colorActiveOrdtColorsGreen7003 : childProps.isHovered ? colorActiveOrdtColorsGreen7002 : dtColorsNeutral400}
/>
)}
</SubMenuTab>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Launchers'}>
<Launchers
  viewPath={`${viewPath}/Launchers`}
 left={left}
 top={top}
 innerRef={setInnerRef}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'AppComponent'}>
<AppComponent
  viewPath={`${viewPath}/AppComponent`}
 innerRef={setInnerRef}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}